import React, { useEffect } from "react";
type PlayerScoreAlertProps = {
    score: number;
    onClose: () => void;
};

function formatScoreFa(score: number): string {
    return score.toLocaleString("fa-IR");
}

export default function PlayerScoreAlert({ score, onClose }: PlayerScoreAlertProps) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    const scoreLabel = formatScoreFa(score);

    return (
        <div
            className="pointer-events-auto fixed inset-0 z-[60] flex items-center justify-center p-4 backdrop-blur-[16px]"
            style={{
                backgroundImage:
                    "linear-gradient(180deg, rgba(26, 27, 24, 0.4) 4.2%, rgb(26, 27, 24) 80.5%), linear-gradient(90deg, rgba(26, 27, 24, 0.5) 0%, rgba(26, 27, 24, 0.5) 100%)",
            }}
            onClick={onClose}
        >
            <div
                dir="rtl"
                className="flex w-full max-w-[380px] flex-col items-center gap-2"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex w-full flex-col items-center justify-center rounded-xl bg-main-radial-gradient-t px-8 py-6">
                    <div className="relative z-10 flex flex-col items-center gap-3 text-center">
                        <p className="text-base font-semibold leading-normal text-input">
                            🎉 تبریک
                        </p>
                        <p className="text-4xl font-bold leading-[1.35]">
                            <span className="text-lime-400">{scoreLabel} امتیاز</span>
                            <span className="text-[#f7fee7]"> دریافت کردید</span>
                        </p>
                        <p className="text-base font-light leading-normal text-input">
                            شما فیلم را با موفقیت تا انتها تماشا کردید و {scoreLabel} امتیاز به
                            حساب شما اضافه شد.
                        </p>
                    </div>
                </div>

                <button
                    type="button"
                    onClick={onClose}
                    className="flex h-11 w-full cursor-pointer items-center justify-center rounded-lg border border-zinc-700 px-3 py-2.5 text-sm leading-normal text-input transition hover:border-lime-400/50"
                >
                    باشه!
                </button>
            </div>
        </div>
    );
}
